import _ from 'lodash'
import { ActionTree } from 'vuex'

import { PurchaseService } from '../../../services/api/purchase'
import { RootState } from '../../types'
import { PurchaseState } from './types'

export const actions: ActionTree<PurchaseState, RootState> = {
  async loadLatest({ commit, state }, payload?: { force?: boolean }) {
    if (!_.get(payload, 'force') && !_.isNull(state.latestItem)) {
      return
    }

    const result = (await new PurchaseService().latest())

    if (result.isLeft()) {
      const error = result.value

      commit('errorOnLoad', error)

      return
    }

    const latestItem = result.value.foldL(
      () => null,
      value => value
    )

    commit('listLatest', latestItem)
  },
}
